import React, { Fragment } from 'react';
import { hasAny } from '../utils';

const Street = ({ street, number, aptNumber }) =>
  hasAny(street, number) ? (
    <div>
      {number}
      {hasAny(street, number) && ' '}
      {street}
      {!!aptNumber && ' '}
      {!!aptNumber && aptNumber}
    </div>
  ) : null;

const Address = ({ address1, address2 }) => (
  <Fragment>
    <div>{address1}</div>
    <div>{address2}</div>
  </Fragment>
);

const Territory = ({ zipcode, city, regionCode, regionName }) => {
  const region = regionCode || regionName;

  return hasAny(zipcode, city, regionCode, regionName) ? (
    <div>
      {city}
      {hasAny(city, region) && ' '}
      {region}
      {hasAny(city, region) && zipcode && ' '}
      {zipcode}
    </div>
  ) : null;
};

const CA = ({
  street,
  number,
  aptNumber,
  address1,
  address2,
  city,
  zipcode,
  regionCode,
  regionName,
  countryName,
}) => {
  const addressMarkup = hasAny(street, number) ? (
    <Street street={street} number={number} aptNumber={aptNumber} />
  ) : (
    <Address address1={address1} address2={address2} />
  );

  const territoryMarkup = (
    <Territory zipcode={zipcode} city={city} regionCode={regionCode} regionName={regionName} />
  );

  const countryMarkup = hasAny(countryName) && <div>{countryName}</div>;

  return (
    <Fragment>
      {addressMarkup}
      {territoryMarkup}
      {countryMarkup}
    </Fragment>
  );
};

export default CA;
